import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const PayslipCard = ({ payslip, onDownload }) => {
  const formatCurrency = (amount) => {
    return `K${amount?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  };

  const statusColors = {
    draft: 'bg-muted text-muted-foreground',
    generated: 'bg-success/10 text-success',
    sent: 'bg-primary/10 text-primary',
    failed: 'bg-error/10 text-error'
  };

  return (
    <div className="bg-card border border-border rounded-lg p-5 hover:shadow-md transition-smooth">
      <div className="flex items-start justify-between mb-4">
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-2">
            <h4 className="font-semibold text-foreground">
              {payslip?.payslipNumber}
            </h4>
            <span className={`px-2 py-1 rounded text-xs font-medium ${statusColors?.[payslip?.payslipStatus]}`}>
              {payslip?.payslipStatus?.toUpperCase()}
            </span>
          </div>
          <div className="flex items-center gap-4 text-sm text-muted-foreground">
            <span>
              <Icon name="Calendar" size={14} className="inline mr-1" />
              {new Date(payslip?.payPeriodStart)?.toLocaleDateString()} - {new Date(payslip?.payPeriodEnd)?.toLocaleDateString()}
            </span>
            <span>
              <Icon name="DollarSign" size={14} className="inline mr-1" />
              Payment: {new Date(payslip?.paymentDate)?.toLocaleDateString()}
            </span>
          </div>
        </div>
      </div>

      {payslip?.details && (
        <div className="grid grid-cols-2 gap-4 mb-4 p-4 bg-muted/30 rounded-lg">
          <div>
            <p className="text-xs text-muted-foreground">Gross Pay</p>
            <p className="text-lg font-semibold text-foreground">{formatCurrency(payslip?.details?.grossPay)}</p>
          </div>
          <div>
            <p className="text-xs text-muted-foreground">Net Pay</p>
            <p className="text-lg font-semibold text-success">{formatCurrency(payslip?.details?.netPay)}</p>
          </div>
          <div>
            <p className="text-xs text-muted-foreground">SWT Deduction</p>
            <p className="text-sm text-foreground">{formatCurrency(payslip?.details?.swtAmount)}</p>
          </div>
          <div>
            <p className="text-xs text-muted-foreground">NASFUND</p>
            <p className="text-sm text-foreground">{formatCurrency(payslip?.details?.employeeSuper)}</p>
          </div>
        </div>
      )}

      <div className="flex gap-2">
        <Button
          variant="outline"
          size="sm"
          iconName="Download"
          onClick={() => onDownload?.(payslip)}
          disabled={payslip?.payslipStatus !== 'generated' && payslip?.payslipStatus !== 'sent'}
          className="flex-1"
        >
          Download PDF
        </Button>
        <Button
          variant="ghost"
          size="sm"
          iconName="Eye"
          disabled={payslip?.payslipStatus === 'draft'}
        >
          View Details
        </Button>
      </div>
    </div>
  );
};

export default PayslipCard;
